import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Label } from '@wf/sw-ui-kit';

import { LicenseField } from '../LicenseField';

import { HeaderTabFields } from '../../types/fieldEnums';
import { Flow } from '../../types/enums';

import { fieldNameConverter } from '../../helpers/fieldNameConverter';
import { RimmEntityType } from '../../../rimm/data/rimmEntityEnums';
import { fieldConfigsSelector } from '../../store/selectors';

function CountryOfExportOrImport() {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const fieldConfigs = useSelector(fieldConfigsSelector);

  const formFlow = useWatch({ name: HeaderTabFields.flow });

  const formFlowName = formFlow === Flow.EX ? 'Destination' : 'Export';
  const formFlowHelpText =
    formFlow === Flow.EX
      ? 'Country into which the goods are to be imported'
      : 'Country from which the goods are to be exported';

  const countryOfExportOrImportEnabled =
    fieldConfigs[fieldNameConverter(HeaderTabFields.countryOfDestinationCode)]?.hidden === false;

  return countryOfExportOrImportEnabled ? (
    <LicenseField.RimmSelectField
      label={<Label helpText={t(formFlowHelpText)}>{t(`Country of ${formFlowName}`)}</Label>}
      configName={HeaderTabFields.countryOfDestinationCode}
      name={HeaderTabFields.countryOfDestinationCode}
      entity={RimmEntityType.country}
      placeholder={t('Select...')}
      setValue={setValue}
      withTag
    />
  ) : null;
}

export default CountryOfExportOrImport;
